import { apiClient } from '@admin-ui-root/src/app/lib/apiClient';
import { fileDeliveryApiUrl } from '@admin-ui-root/src/app/pages/FileDelivery/api/api';
import type { ApiContext } from '../shared';
import type { Profile } from './types';

export const listProfiles = async (ctx: ApiContext): Promise<Profile[]> => {
  const api = apiClient();

  const response = await api
    .get(fileDeliveryApiUrl('profiles'), {
      headers: {
        'x-fds-profile': ctx.serviceAccount,
        'x-c2fo-dc': ctx.datacenter,
      },
    })
    .json<unknown>();

  // Handle empty object response when no results are found
  if (!response || typeof response !== 'object' || !('profiles' in response)) {
    return [];
  }

  const typedResponse = response as { profiles: Profile[] };
  return typedResponse.profiles || [];
};
